import { render, staticRenderFns } from "./topIpGroupModel.vue?vue&type=template&id=a28c50aa"
import script from "./topIpGroupModel.vue?vue&type=script&lang=js"
export * from "./topIpGroupModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports